import { Route, Routes, Navigate } from 'react-router';
import { useSelector } from 'react-redux';

import { selectUserPermissions, selectUserRoles } from '@store/auth';

import ConfigIcon from '@assets/images/payment-config/config.png';
import Currency from '@assets/images/payment-config/currency-details.png';
import HashTag from '@assets/images/payment-config/hashtag.png';
import ToggleIcon from '@assets/images/payment-config/toggles.png';
import ErrorConfigIcon from '@assets/images/payment-config/error-config.png';

import { SidePanelImage } from '../../components/styledComponents';
import ApplicationTemplate from '../dashboard/components/ApplicationTemplate/ApplicationTemplate';

// Pages
import PaymentConfigList from './pages/PaymentConfigList';
import ToggleList from './pages/TogglesList';
import ChannelHashesList from './pages/ChannelHashes';
import CurrencyDetails from './pages/CurrencyDetails';
import ErrorConfig from './pages/ErrorConfig';

import { getFirstRoute } from '../../utils/utils';

import {
  CHANNEL_HASHES_LIST,
  CONFIG_LIST,
  CURRENCY_DETAILS,
  TOGGLES_LIST,
  ERROR_CONFIG,
} from './payment-configuration.breadcrumbs';
import { ROLES } from '../../app/App.constants';

const tabs = [
  {
    title: 'Channel Hashes',
    icon: (
      <SidePanelImage
        src={HashTag}
        alt="Channel Hashes"
      />
    ),
    path: CHANNEL_HASHES_LIST,
    roles: [ROLES.ROLE_CHANNEL_HASH_VIEW, ROLES.ROLE_CHANNEL_HASH_EDIT,ROLES.ROLE_TOGGLZ_EDIT],
  },
  {
    title: 'Configurations',
    icon: (
      <SidePanelImage
        src={ConfigIcon}
        alt="Config List"
      />
    ),
    path: CONFIG_LIST,
    roles: [
      ROLES.ROLE_PAYMENT_CONFIGURATIONS_VIEW,
      ROLES.ROLE_PAYMENT_CONFIGURATIONS_EDIT,
    ],
  },
  {
    title: 'Currency Details',
    icon: (
      <SidePanelImage
        src={Currency}
        alt="Currency Details"
      />
    ),
    path: CURRENCY_DETAILS,
    roles: [ROLES.ROLE_CURRENCY_DETAILS_VIEW, ROLES.ROLE_CURRENCY_DETAILS_EDIT],
  },
  {
    title: 'Toggles',
    icon: (
      <SidePanelImage
        src={ToggleIcon}
        alt="Toggles"
      />
    ),
    path: TOGGLES_LIST,
    roles: [ROLES.ROLE_TOGGLZ_VIEW, ROLES.ROLE_TOGGLZ_EDIT],
  },
  {
    title: 'Error Config',
    icon: (
      <SidePanelImage
        src={ErrorConfigIcon}
        alt="Error Config"
      />
    ),
    path: ERROR_CONFIG,
    roles: [ROLES.ROLE_ERROR_CONFIG_VIEW, ROLES.ROLE_ERROR_CONFIG_EDIT],
  },
];

function ConfigList() {
  const permissions = useSelector(selectUserPermissions);
  const userRoles = useSelector(selectUserRoles);
  const firstRoute = getFirstRoute(userRoles, tabs);

  return (
    <ApplicationTemplate menu={tabs}>
      <Routes>
        <Route
          path="/"
          element={
            <Navigate
              to={firstRoute}
              replace
            />
          }
        />
        <Route
          path="features/list"
          exact
          element={<PaymentConfigList permissions={permissions} />}
        />
        <Route
          path="toggles/list"
          exact
          element={<ToggleList permissions={permissions} />}
        />
        <Route
          path="channel-hashes/list"
          exact
          element={<ChannelHashesList permissions={permissions} />}
        />
        <Route
          path="currency-details"
          exact
          element={<CurrencyDetails permissions={permissions} />}
        />
        <Route
          path="error-config"
          exact
          element={<ErrorConfig permissions={permissions} />}
        />
      </Routes>
    </ApplicationTemplate>
  );
}

export default ConfigList;
